import { View, StyleSheet, ViewStyle } from 'react-native'
import { TotalUsersCard } from './TotalUsersCard'
import { ActiveGamesCard } from './ActiveGamesCard'
import { UsersPlayingCard } from './UsersPlayingCard'
import { ActiveBotsCard } from './ActiveBotsCard'
import { GamesOnlyBots } from './GamesOnlyBots'
import { useBreakPointValue } from '../../WebWrapper'
import { useQuery } from 'convex/react'
import { api } from '@ppwr/convex/_generated/api'

export const Metrics = () => {
  const direction = useBreakPointValue<ViewStyle['flexDirection']>({
    default: 'column',
    md: 'row'
  })

  const activeGamesInfo = useQuery(api.games.queries.getDashboardActiveGamesInfo)

  const styles = StyleSheet.create({
    container: {
      flexDirection: direction,
      flexWrap: 'wrap',
      gap: 24
    }
  })

  return (
    <View style={styles.container}>
      <TotalUsersCard />
      {/* TODO: Replace with Auth0 Management API total users count once we add a backend endpoint for it */}
      <UsersPlayingCard metric={activeGamesInfo?.activeUsersCount?.toString() || '0'} />
      <ActiveGamesCard metric={activeGamesInfo?.activeGamesCount?.toString() || '0'} />
      <ActiveBotsCard metric={activeGamesInfo?.activeBotsCount?.toString() || '0'} />
      <GamesOnlyBots metric={activeGamesInfo?.activeGamesWithOnlyBotsCount?.toString() || '0'} />
    </View>
  )
}
